export class DateHelper {
  static formatDateMMDDYY = (timestamp: string | number | null) => {
    if (!timestamp) return ''

    // Handle ISO string format or timestamp number
    const date =
      typeof timestamp === 'string'
        ? new Date(timestamp)
        : new Date(Number(timestamp))

    if (isNaN(date.getTime())) return ''

    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    const year = String(date.getFullYear())

    return `${month}/${day}/${year}`
  }

  static formatDatetime = (timestamp: string | number | null) => {
    if (!timestamp) return ''

    // Handle ISO string format (e.g., "2026-02-05T22:40:58-03:00")
    // or timestamp number
    const date =
      typeof timestamp === 'string'
        ? new Date(timestamp)
        : new Date(Number(timestamp))

    if (isNaN(date.getTime())) return ''

    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    const year = String(date.getFullYear())
    const hour = String(date.getHours()).padStart(2, '0')
    const minute = String(date.getMinutes()).padStart(2, '0')

    return `${month}/${day}/${year} ${hour}:${minute}`
  }

  /**
   * Formats a date/timestamp to the backend expected format: yyyy-MM-dd'T'HH:mm:ssXXX
   * This matches the Java SimpleDateFormat pattern used by the backend (Env.DATE_FORMAT)
   * @param timestamp - Timestamp in milliseconds or null
   * @returns Formatted date string in format yyyy-MM-dd'T'HH:mm:ssXXX (e.g., "2026-03-16T17:31:07+00:00") or null
   */
  static formatDateForBackend = (timestamp: number | null): string | null => {
    if (!timestamp) return null

    const date = new Date(timestamp)
    if (isNaN(date.getTime())) return null

    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    const hours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')
    const seconds = String(date.getSeconds()).padStart(2, '0')

    // Get timezone offset in format +HH:mm or -HH:mm
    const offset = -date.getTimezoneOffset()
    const offsetHours = String(Math.floor(Math.abs(offset) / 60)).padStart(
      2,
      '0'
    )
    const offsetMinutes = String(Math.abs(offset) % 60).padStart(2, '0')
    const offsetSign = offset >= 0 ? '+' : '-'

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${offsetSign}${offsetHours}:${offsetMinutes}`
  }
}
